import { CloudImage, Heading, Text } from "@fluidattacks/design";
import { Fragment } from "react";
import { Helmet } from "react-helmet";

import { ResultContainer, ResultWrapper } from "./styles";

interface ICliOauthResultProps {
  message: string;
  title: string;
}

/*
 * Branded terminal screen the browser lands on after a CLI login, mirroring the
 * web login's logo and typography. The CLI's loopback server redirects here
 * (`/auth/cli/done`), and the login pages route here on failure.
 */
const CliOauthResult: React.FC<ICliOauthResultProps> = ({
  message,
  title,
}: ICliOauthResultProps): JSX.Element => (
  <Fragment>
    <Helmet>
      <title>{`${title} | Fluid Attacks`}</title>
    </Helmet>
    <ResultWrapper>
      <ResultContainer>
        <CloudImage
          alt={"Fluid Attacks Logo"}
          publicId={"integrates/login/loginLogoExtended"}
          width={"220px"}
        />
        <Heading fontWeight={"bold"} size={"lg"} textAlign={"center"}>
          {title}
        </Heading>
        <Text size={"lg"} textAlign={"center"}>
          {message}
        </Text>
      </ResultContainer>
    </ResultWrapper>
  </Fragment>
);

export { CliOauthResult };
